import { TProductAggregatedState } from './types';

export function setProductAggregated(
  state: TProductAggregatedState,
  data: TProductAggregatedState['productAggregated'],
) {
  state.productAggregated = data;
}
